<template>
    <div class="form-group">
        <label v-bind:for="id" v-html="label"></label>
        <input v-money="money"
               v-bind:class="classe"
               v-bind:value="value"
               v-bind:name="name"
               v-bind:id="id"
               v-bind:placeholder="placeholder"
               v-bind:required="required"
               v-bind:disabled="disabled"
               v-bind:readonly="readonly" />
    </div>
</template>

<script>

    import { mask } from 'vue-the-mask'
    import { VMoney }  from 'v-money'

    export default {
        name: 'input-money',
        directives: { mask },
        props: {
            options: {
                type: Object,
                default: () => ({}),
            }
        },

        data () {
            return {
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: ' ',
                    precision: 2,
                    masked: true
                },
                name: (this.options.name) ? this.options.name : 'number',
                id: (this.options.id) ? this.options.id : 'number',
                value: (this.options.value) ? this.options.value : '',
                placeholder: (this.options.placeholder) ? this.options.placeholder : '',
                label: (this.options.label) ? this.options.label : 'R$',
                classe: (this.options.class) ? 'form-control ' + this.options.class : 'form-control',
                required: (this.options.required) ? true : false,
                disabled: (this.options.disabled) ? this.options.disabled : false,
                readonly: (this.options.readonly) ? this.options.readonly : false,

            }
        },

        directives: {
            money: VMoney
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Money.vue